import { resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, createElementVNode, createApp } from 'vue';
import { createComponent } from './utils/create-component';
import Mask from './mask';
import Loading from './loading';
import propTypes from './utils/prop-types';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 加载icon尺寸
   */
  spinnerSize: propTypes.number().def(40),
  /**
   * 加载icon颜色
   */
  spinnerColor: propTypes.string(),
  /**
   * 内置loading类型
   */
  type: propTypes.string().def('default'),
  /**
   * mask颜色
   */
  maskColor: propTypes.string().def('rgba(0, 0, 0, 0.4)'),
  /**
   * 自定义class
   */
  customClass: propTypes.string()
};

var _components;
var _createComponent = createComponent('activity-indicator'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: (_components = {}, _defineProperty(_components, Mask.name, Mask), _defineProperty(_components, Loading.name, Loading), _components),
  props: props,
  setup: function setup() {
    return {
      className: className
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_loading = resolveComponent("sp-loading");
  var _component_sp_mask = resolveComponent("sp-mask");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass([_ctx.className, _ctx.customClass])
  }, [createVNode(_component_sp_mask, {
    modelValue: true,
    duration: 300,
    maskCloseable: false,
    maskStyle: {
      backgroundColor: _ctx.maskColor
    }
  }, {
    "default": withCtx(function () {
      return [createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__inner"))
      }, [createVNode(_component_sp_loading, {
        size: _ctx.spinnerSize,
        color: _ctx.spinnerColor,
        type: _ctx.type
      }, null, 8 /* PROPS */, ["size", "color", "type"])], 2 /* CLASS */)];
    }),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["maskStyle"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/activity-indicator/activity-indicator.vue";

var instance = null;
script.show = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    appendTo = _ref.appendTo,
    spinnerColor = _ref.spinnerColor,
    _ref$maskColor = _ref.maskColor,
    maskColor = _ref$maskColor === void 0 ? 'rgba(0, 0, 0, 0.4)' : _ref$maskColor,
    _ref$spinnerSize = _ref.spinnerSize,
    spinnerSize = _ref$spinnerSize === void 0 ? 40 : _ref$spinnerSize,
    customClass = _ref.customClass,
    type = _ref.type;
  if (instance) {
    return instance;
  }
  var app = createApp(script, {
    spinnerColor: spinnerColor,
    maskColor: maskColor,
    spinnerSize: spinnerSize,
    customClass: customClass,
    type: type
  });
  var vm = app.mount(document.createElement('div'));
  instance = {
    vm: vm,
    app: app
  };
  var parent = appendTo || document.body;
  parent.appendChild(vm.$el);
  return vm;
};
script.hide = function () {
  if (!instance) {
    return;
  }
  var _instance = instance,
    app = _instance.app,
    vm = _instance.vm;
  instance = null;
  app.unmount();
  var parent = vm.$el && vm.$el.parentNode;
  if (parent) {
    parent.removeChild(vm.$el);
  }
};
var _ActivityIndicator = script;

export { _ActivityIndicator as default };
